module.exports = __webpack_public_path__ + "img/ico_speaker.ea3d7634.svg";